import { h, Component } from 'preact'

import classList from '../etc/classList.js'

export default function Button({
	className:c = null,
	type = 'button',
	disabled = false,
	onClick = null,
	children,
	label,
}) {
	const className = classList('Button', c)

	return (
		<button
			class={ className() }
			type={ type }
			onclick={ disabled ? null : onClick }
			disabled={ disabled }
			title={ label }
		>
			{ children || label }
		</button>
	)
}
